import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const ProfilePage = lazy(() =>
    import(/* webpackChunkName: "profile" */ '@profile/ui/ProfilePage').then(m => ({ default: m.ProfilePage })),
);
export const profileLocations: Location[] = [
    {
        url: '/profile',
        Component: ProfilePage,
    },
];
